import Vue from 'vue'
import Vuex from 'vuex'
import user from './user.js'
 
//1.安装插件
Vue.use(Vuex)
 
//2.创建对象
const store = new Vuex.Store({
    modules:{
        user
    }
})
//3.导出使用
export default store